// import { reduce } from 'cypress/types/bluebird'
import glamorous from 'glamorous'
import React, { forwardRef } from 'react'
import { BodyText } from '@paypalcorp/pp-react'

import getContent from 'pp-react-l10n'
const l10n = getContent('pages/seller/details')

const Wrapper = glamorous.div({
  margin: '0.25rem 0 2rem 0.75rem',
})

const SuggestionsList = glamorous.ul({
  listStyleType: 'none',
  margin: 0,
})
const SuggestionRow = glamorous.li({
  // borderTop: '0.03125rem dotted #B7BCBF',
  padding: '0.25rem 0',
  color: '#0070BA',
  fontSize: '0.9375rem',
  lineHeight: '1.09375rem',
  textAlign: 'left',
})

const Availability = forwardRef((props, ref) => {
  const { onSelect, suggestions } = props

  const suggestionListItems = suggestions.map(suggestion => {
    return (
      <SuggestionRow key={`id-${suggestion}`}>
        <button
          type="button"
          className="vx_btn-link"
          name="businessHandle"
          value={suggestion}
          onClick={onSelect}
        >
          {suggestion}
        </button>
      </SuggestionRow>
    )
  })

  return (
    <>
      <Wrapper ref={ref}>
        <BodyText size="sm">{l10n('main.availability.heading')}</BodyText>
        <SuggestionsList>{suggestionListItems}</SuggestionsList>
      </Wrapper>
    </>
  )
})

export default Availability
